import { useQuery } from "react-query";
import { LocalizationUtils } from "component-library";
import facetService from "shared/services/api/facet/facetService";
import { FacetCategory } from "shared/models/facet";

const FETCH_PRODUCTION_TYPES = "FETCH_PRODUCTION_TYPES";

export function useGetProductionType() {
  const locale = LocalizationUtils.getUserLocalizationPreference().locale;

  const { data, isLoading } = useQuery(
    [FETCH_PRODUCTION_TYPES, locale],
    async () => {
      const loadedCategories = await facetService.find(
        [FacetCategory.ProductionType],
        locale
      );

      return loadedCategories.reduce((acc, { facetGroups }) => {
        const facets = facetGroups.reduce(
          (acc, { facets }) => [...acc, ...facets],
          []
        );

        return [...acc, ...facets];
      }, []);
    }
  );

  return {
    productionTypes: data || [],
    productionTypesLoading: isLoading,
  };
}
